import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ImageContent } from "@obg/ngx.core.content";
import { ConfigService } from "@obg/ngx.global";

@Injectable()
export class BannerConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getFallbackImage(): ImageContent | undefined {
		return this.configService.get((x) => x.coreUi.banner.fallbackImage, undefined) as ImageContent;
	}
}
